export class QueryParams {
  constructor(link) {
    this.link = link;
    this.params = this.extractParams();
  }

  extractParams() {
    const queryParams = this.link.split("?");

    if (queryParams.length === 2) {
      const queryString = queryParams[1];

      const params = queryString
        .split("&")
        .map((queryParam) => queryParam.split("="))
        .reduce((acc, [key, value]) => {
          acc[key] = value;
          return acc;
        }, {});

      return params;
    }

    return {};
  }

  get(key) {
    return this.params[key];
  }

  has(key) {
    if (this.params[key]) {
      return true;
    }
    return false;
  }
}
